export default __webpack_public_path__ + "static/media/photograpy-01.e91f255f.jpg";